import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('heritage_token');
      localStorage.removeItem('heritage_usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
